import { type AdminClientSessionsResponse, adminClientSessionsResponseSchema } from '@si/types';
import { get, objectToQueryParams } from '@si/utils';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from './queryKeys';

interface Params {
  enabled?: boolean;
  first?: number;
  max?: number;
  dedupeUsers?: boolean;
}

const emptyObject = {} as const;

export function useAdminSessions({
  enabled = true,
  first = 0,
  max = 100,
  dedupeUsers = true,
}: Params = emptyObject) {
  const url = `/admin/sessions${objectToQueryParams({ first, max, dedupeUsers })}`;

  const { data, error, isLoading, isRefetching, refetch } = useQuery<AdminClientSessionsResponse>({
    queryKey: queryKeys.getAdminSessions(first, max, dedupeUsers),
    queryFn: () => get({ url, schema: adminClientSessionsResponseSchema }),
    enabled,
    refetchInterval: 30000,
  });

  return {
    sessionsData: data,
    users: data?.users ?? [],
    sessions: data?.sessions ?? [],
    pagination: data?.pagination,
    client: data?.client,
    error,
    isLoading,
    isRefetching,
    refetch,
  };
}
